import * as yup from 'yup';

const phoneRegExp = /^(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

const caregiverRowSchema = yup.object().shape({
  selected: yup.boolean(),
  isFromSis: yup.boolean(),
  firstName: yup.string().when('selected', {
    is: true,
    then: (schema) => schema.required('First name is required'),
    otherwise: (schema) => schema,
  }),
  lastName: yup.string().when('selected', {
    is: true,
    then: (schema) => schema.required('Last name is required'),
    otherwise: (schema) => schema,
  }),
  relationship: yup.string(),
  phoneNumber: yup.string().when('selected', {
    is: true,
    then: (schema) => schema.required('Phone number is required').matches(phoneRegExp, 'Enter a valid phone number'),
    otherwise: (schema) => schema,
  }),
  email: yup.string().email('Enter a valid email'),
});

export const importCaregiverFormSchema = yup.object().shape({
  caregivers: yup.array().of(caregiverRowSchema),
});
